<template>
  <div class="btn-wrapper">
    <div class="btn" @click="onClick">{{ btnConfig.btnText }}</div>
  </div>
</template>
<script>
import eventBus from '@/summerCamp/utils/bus'

export default {
  name: 'commonButton',
  props: {
    btnConfig: {
      type: Object,
      required: true
    }
  },
  methods: {
    onClick() {
      const { from, fn } = this.btnConfig
      eventBus.$emit('index-btn-trigger', { from, fn })
    }
  }
}
</script>
<style lang="less" scoped>
.btn-wrapper {
  // display: inline-block;
  text-align: center;
  // animation: breathe 1s linear 500ms infinite alternate;

  .btn {
    display: inline-block;
    width: 260px;
    height: 44px;
    font-size: 18px;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 44px;
    color: #fff9d7;
    background: linear-gradient(60deg, #e51e1d 0%, #e62518 100%);
    border: 1px solid #ab1d1d;
    border-radius: 27px;
  }

  @keyframes breathe {
    from {
      transform: scale(1);
    }

    to {
      transform: scale(0.9);
    }
  }
}
</style>
